<template>
  <v-tabs-items :value="current_item" touchless>
    <v-tab-item :value="'GeneralInformation'">
      <personal-info-tab/>
    </v-tab-item>
    <v-tab-item :value="'PGAS'">
      <the-scholarship-competition-tab/>
    </v-tab-item>
    <v-tab-item :value="'AchievementPortfolio'">
      <achievement-list-tab/>
    </v-tab-item>
    <v-tab-item :value="'PortfolioDocuments'">
      <file-list-tab/>
    </v-tab-item>
    <v-tab-item :value="'Rating'" class="pa-0">
      <rating-tab/>
    </v-tab-item>
  </v-tabs-items>
</template>

<script>
import {mapState} from "vuex";

const PersonalInfoTab = () => import("../Tab/PersonalInfoTab");
const AchievementListTab = () => import("../Tab/AchievementListTab");
const FileListTab = () => import("../Tab/FileListTab");
const RatingTab = () => import("../Tab/RatingTab");
const TheScholarshipCompetitionTab = () => import("../Tab/TheScholarshipCompetitionTab.vue");

export default {
  name: "MainCard",
  components: {
    TheScholarshipCompetitionTab,
    PersonalInfoTab,
    AchievementListTab,
    FileListTab,
    RatingTab,
  },

  computed: {
    ...mapState({
      current_item:state => state.achievement.current_item_tab,
    })
  },
}
</script>

<style scoped>

</style>